var Component = require("!../../../../../../../../../../../L180/prototypes/uni-uswebapp/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../../../../../../L180/prototypes/uni-uswebapp/node_modules/vue-loader/lib/selector?type=script&index=0!./Attendance.vue"),
  /* template */
  require("!!../../../../../../../../../../../L180/prototypes/uni-uswebapp/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-3cba05d8\",\"hasScoped\":false,\"transformToRequire\":{\"video\":\"src\",\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"}}!../../../../../../../../../../../L180/prototypes/uni-uswebapp/node_modules/vue-loader/lib/selector?type=template&index=0!./Attendance.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Attendance.vue
// module id = 386
// module chunks = 7